import { useEffect, useRef, useState } from "react";
import { InfoIcon } from "../components/Icons";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";

type HelpButtonProps = {
  onShowKeyboardShortcuts: () => void;
};

export function HelpButton({ onShowKeyboardShortcuts }: HelpButtonProps) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const player = useVideoPlayer2();

  useEffect(() => {
    if (!open) return;

    function handleClick(e: MouseEvent) {
      if (
        !btnRef.current?.contains(e.target as Node) &&
        !menuRef.current?.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  const handleKeyboardShortcutsClick = () => {
    onShowKeyboardShortcuts();
    setOpen(false);
  };

  return (
    <>
      <button
        ref={btnRef}
        className="video-player-2-btn video-player-2-help hidden md:flex"
        onClick={() => setOpen(o => !o)}
        title={player.trans("help")}
        aria-label={player.trans("help")}>
        <InfoIcon />
      </button>
      {open && (
        <div
          ref={menuRef}
          className="video-player-2-help-menu"
          role="menu"
          aria-label={player.trans("help") + " menu"}>
          <button
            className="video-player-2-help-menu-item"
            onClick={handleKeyboardShortcutsClick}
            role="menuitem">
            {player.trans("keyboardShortcuts")}
          </button>
        </div>
      )}
    </>
  );
}

